import { PhysicalInventoryAuditType } from '~/db_types';
export const PhysicalInventoryAuditTypeDisplay = new Map([
    [PhysicalInventoryAuditType.SAMPLE, 'Sample'],
    [PhysicalInventoryAuditType.WALL_TO_WALL, 'Wall to wall']
]);
